export const ErrorCodes = {
  // Auth
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  INVALID_REQUEST: 'INVALID_REQUEST',
  MISSING_MODULE_PERMISSION: 'MISSING_MODULE_PERMISSION',
  DEVICE_NOT_PAIRED: 'DEVICE_NOT_PAIRED',
  DEVICE_PAIRING_REQUESTED: 'DEVICE_PAIRING_REQUESTED',
  DEVICE_NOT_FOUND: 'DEVICE_NOT_FOUND',
  NEW_IP_FOR_DEVICE_REQUESTED: 'NEW_IP_FOR_DEVICE_REQUESTED',
  CANNOT_DELETE_LAST_DEVICE_IP: 'CANNOT_DELETE_LAST_DEVICE_IP',
  INVALID_PASSWORD_OR_USERNAME: 'INVALID_PASSWORD_OR_USERNAME',
  DEPLOY_CLIENT_ALREADY_EXISTS: 'DEPLOY_CLIENT_ALREADY_EXISTS',

  // Notification
  EMAIL_ALREADY_SUBSCRIBED: 'EMAIL_ALREADY_SUBSCRIBED',
  SUBSCRIPTION_NOT_FOUND: 'SUBSCRIPTION_NOT_FOUND',
  EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
  VERIFICATION_EMAIL_COOLDOWN: 'VERIFICATION_EMAIL_COOLDOWN',
  VERIFICATION_TOKEN_NOT_FOUND: 'VERIFICATION_TOKEN_NOT_FOUND',
  VERIFICATION_TOKEN_EXPIRED: 'VERIFICATION_TOKEN_EXPIRED',
  UNSUBSCRIBE_TOKEN_NOT_FOUND: 'UNSUBSCRIBE_TOKEN_NOT_FOUND',
  MISSING_REQUIRED_ARGUMENTS: 'MISSING_REQUIRED_ARGUMENTS',
  UNKNOWN_NOTIFICATION_TYPE: 'UNKNOWN_NOTIFICATION_TYPE',

  // Task
  CANNOT_CREATE_TASK_FOR_NOT_ACTIVE_RESIDENT:
    'CANNOT_CREATE_TASK_FOR_NOT_ACTIVE_RESIDENT',
  START_DATE_MUST_BE_IN_THE_FUTURE: 'START_DATE_MUST_BE_IN_THE_FUTURE',
  CANNOT_UNCOMPLETE_TASK: 'CANNOT_UNCOMPLETE_TASK',
  TASK_ALREADY_COMPLETED: 'TASK_ALREADY_COMPLETED',
  TASK_ALREADY_REJECTED: 'TASK_ALREADY_REJECTED',
  TASK_NOT_FOUND: 'TASK_NOT_FOUND',
  TASK_MONTH_IS_ARCHIVED: 'TASK_MONTH_IS_ARCHIVED',
  INVALID_ARCHIVE_MONTH: 'INVALID_ARCHIVE_MONTH',

  // User
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  PERSONAL_NUMBER_ALREADY_EXISTS: 'PERSONAL_NUMBER_ALREADY_EXISTS',
  INVALID_USER_GROUP: 'INVALID_USER_GROUP',
  USER_DOES_NOT_HAVE_ANY_GROUP_ASSIGNED:
    'USER_DOES_NOT_HAVE_ANY_GROUP_ASSIGNED',
  EMAIL_ALREADY_IN_USE: 'EMAIL_ALREADY_IN_USE',
  COULD_NOT_CREATE_USER: 'COULD_NOT_CREATE_USER',
  COULD_NOT_UPDATE_USER: 'COULD_NOT_UPDATE_USER',
  COULD_NOT_RESET_PASSWORD: 'COULD_NOT_RESET_PASSWORD',
  COULD_NOT_GENERATE_PASSWORD_FOR_THIS_GROUP:
    'COULD_NOT_GENERATE_PASSWORD_FOR_THIS_GROUP',

  // Resident
  RESIDENT_NOT_FOUND: 'RESIDENT_NOT_FOUND',
  RESIDENT_NOT_OPERATIONALLY_ACTIVE: 'RESIDENT_NOT_OPERATIONALLY_ACTIVE',
  RESIDENT_NOT_DEACTIVATED: 'RESIDENT_NOT_DEACTIVATED',
  ACTIVE_RESIDENT_MUST_HAVE_ROOM_ASSIGNED:
    'ACTIVE_RESIDENT_MUST_HAVE_ROOM_ASSIGNED',
  COULD_NOT_DELETE_RESIDENT: 'COULD_NOT_DELETE_RESIDENT',
  COULD_NOT_CREATE_RESIDENT: 'COULD_NOT_CREATE_RESIDENT',
  COULD_NOT_UPDATE_RESIDENT: 'COULD_NOT_UPDATE_RESIDENT',
  RESIDENT_ALREADY_ASSIGNED_TO_ROOM: 'RESIDENT_ALREADY_ASSIGNED_TO_ROOM',
  CONTACT_PERSON_NOT_MATCHING_RESIDENT: 'CONTACT_PERSON_NOT_MATCHING_RESIDENT',
  DUPLICATE_CONTACT_PERSON_EMAIL: 'DUPLICATE_CONTACT_PERSON_EMAIL',
  DUPLICATE_CONTACT_PERSON_PHONE_NUMBER:
    'DUPLICATE_CONTACT_PERSON_PHONE_NUMBER',
  RESIDENT_HAS_ACTIVE_CONTACT_PERSON_ACCOUNT:
    'RESIDENT_HAS_ACTIVE_CONTACT_PERSON_ACCOUNT',
  CONTACT_PERSON_MUST_HAVE_PHONE_OR_EMAIL:
    'CONTACT_PERSON_MUST_HAVE_PHONE_OR_EMAIL',
  ROOM_REQUIRED_FOR_ACCOMMODATION_DATE: 'ROOM_REQUIRED_FOR_ACCOMMODATION_DATE',
  ROOM_NOT_ALLOWED_FOR_FUTURE_ACCOMMODATION_DATE:
    'ROOM_NOT_ALLOWED_FOR_FUTURE_ACCOMMODATION_DATE',

  // Media
  FILE_NOT_FOUND: 'FILE_NOT_FOUND',
  FILE_ALREADY_EXISTS: 'FILE_ALREADY_EXISTS',
  NOT_ENOUGH_SPACE: 'NOT_ENOUGH_SPACE',
  FILE_TOO_BIG: 'FILE_TOO_BIG',
  AVATAR_NAME_NOT_MATCHING_ID: 'AVATAR_NAME_NOT_MATCHING_ID',

  // Inventory
  WAREHOUSE_ACCESS_FORBIDDEN: 'WAREHOUSE_ACCESS_FORBIDDEN',
  WAREHOUSE_NOT_FOUND: 'WAREHOUSE_NOT_FOUND',
  ITEM_NOT_FOUND: 'ITEM_NOT_FOUND',
  INSUFFICIENT_QUANTITY: 'INSUFFICIENT_QUANTITY',

  // Metric
  INVALID_METRIC_ID: 'INVALID_METRIC_ID',

  // Medication
  INVALID_DAY_OF_THE_WEEK: 'INVALID_DAY_OF_THE_WEEK',
  MEDICATION_NOT_FOUND: 'MEDICATION_NOT_FOUND',
  DOSAGE_DETAILS_ARE_REQUIRED: 'DOSAGE_DETAILS_ARE_REQUIRED',
  INVALID_TIME_TYPE: 'INVALID_TIME_TYPE',
  TIME_MUST_BE_SPECIFIED_WHEN_USING_SPECIFIC_TIME_TYPE:
    'TIME_MUST_BE_SPECIFIED_WHEN_USING_SPECIFIC_TIME_TYPE',
  PART_OF_THE_DAY_MUST_BE_SPECIFIED_WHEN_USING_PART_OF_THE_DAY_TIME_TYPE:
    'PART_OF_THE_DAY_MUST_BE_SPECIFIED_WHEN_USING_PART_OF_THE_DAY_TIME_TYPE',
  CANNOT_SPECIFY_BOTH_TIME_AND_PART_OF_THE_DAY:
    'CANNOT_SPECIFY_BOTH_TIME_AND_PART_OF_THE_DAY',

  // Event
  EVENT_NOT_FOUND: 'EVENT_NOT_FOUND',
  START_DATE_CANNOT_BE_AFTER_END_DATE: 'START_DATE_CANNOT_BE_AFTER_END_DATE',
  DATE_RANGE_EXCEEDS_ONE_YEAR: 'DATE_RANGE_EXCEEDS_ONE_YEAR',

  // Room
  ROOM_NOT_FOUND: 'ROOM_NOT_FOUND',
  ROOM_ALREADY_EXISTS: 'ROOM_ALREADY_EXISTS',
  ROOM_OCCUPIED: 'ROOM_OCCUPIED',
  ROOM_FULL: 'ROOM_FULL',
  COULD_NOT_DECREASE_ROOM_CAPACITY_BELOW_ACTUAL_RESIDENTS_AMOUNT:
    'COULD_NOT_DECREASE_ROOM_CAPACITY_BELOW_ACTUAL_RESIDENTS_AMOUNT',

  // Integration
  INTEGRATION_PROVIDER_NOT_FOUND: 'INTEGRATION_PROVIDER_NOT_FOUND',
  INTEGRATION_PROVIDER_ALREADY_EXISTS: 'INTEGRATION_PROVIDER_ALREADY_EXISTS',
  INTEGRATION_INVALID_API_KEY: 'INTEGRATION_INVALID_API_KEY',
  INTEGRATION_PROVIDER_DISABLED: 'INTEGRATION_PROVIDER_DISABLED',
  INTEGRATION_ENDPOINT_NOT_ALLOWED: 'INTEGRATION_ENDPOINT_NOT_ALLOWED',
  INTEGRATION_RATE_LIMIT_EXCEEDED: 'INTEGRATION_RATE_LIMIT_EXCEEDED',

  // Health Log
  DATE_CANNOT_BE_IN_THE_FUTURE: 'DATE_CANNOT_BE_IN_THE_FUTURE',

  // Work Time
  WORK_TIME_NOT_FINISHED: 'WORK_TIME_NOT_FINISHED',
  WORK_TIME_NOT_FOUND: 'WORK_TIME_NOT_FOUND',

  // Job Role
  JOB_ROLE_NOT_FOUND: 'JOB_ROLE_NOT_FOUND',
  JOB_ROLE_ALREADY_EXISTS: 'JOB_ROLE_ALREADY_EXISTS',
  JOB_ROLE_ASSIGNED_TO_USERS: 'JOB_ROLE_ASSIGNED_TO_USERS',
  JOB_ROLE_USED_IN_SHIFTS: 'JOB_ROLE_USED_IN_SHIFTS',
  JOB_ROLE_USED_IN_STAFFING_REQUIREMENTS:
    'JOB_ROLE_USED_IN_STAFFING_REQUIREMENTS',
  JOB_ROLE_USED_IN_TASKS: 'JOB_ROLE_USED_IN_TASKS',
  JOB_ROLE_USED_IN_RECURRING_TASKS: 'JOB_ROLE_USED_IN_RECURRING_TASKS',

  // Work Schedule
  WORK_SCHEDULE_WEEK_ALREADY_PUBLISHED: 'WORK_SCHEDULE_WEEK_ALREADY_PUBLISHED',
  PLANNED_SHIFT_NOT_FOUND: 'PLANNED_SHIFT_NOT_FOUND',
  PLANNED_SHIFT_OVERLAP: 'PLANNED_SHIFT_OVERLAP',
  PLANNED_SHIFT_BLOCKED_BY_ABSENCE: 'PLANNED_SHIFT_BLOCKED_BY_ABSENCE',

  // Absence Request
  ABSENCE_REQUEST_NOT_FOUND: 'ABSENCE_REQUEST_NOT_FOUND',
  ABSENCE_REQUEST_ALREADY_PROCESSED: 'ABSENCE_REQUEST_ALREADY_PROCESSED',
  ABSENCE_REQUEST_CONFLICT: 'ABSENCE_REQUEST_CONFLICT',

  // GraphQL
  COULD_NOT_FIND_MATCHING_RESOLVER: 'COULD_NOT_FIND_MATCHING_RESOLVER',

  // General
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
} as const;

export type ErrorCode = keyof typeof ErrorCodes;
